export default {
  getSubscriptionTypeData (subscriptionTypes, subscriptionTypeId) {
    for (let key in subscriptionTypes) {
      const subscriptionType = subscriptionTypes[key]
      if (subscriptionType.id === subscriptionTypeId) {
        return subscriptionType
      }
    }
    return null
  }
}



// WEBPACK FOOTER //
// ./src/helpers/subscriptionHelpers.js